var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "videoPlayer",
    staticClass: "video-wrapper"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    ref: "videoMedia",
    attrs: {
      "playsinline": "",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url
    }
  })])]), _c('div', {
    staticClass: "player-container"
  }, [_c('div', {
    staticClass: "play-control"
  }, [_c('div', {
    staticClass: "play-button icon-video-play",
    class: {
      hide: _vm.videoPlaying
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.playVideo($event);
      }
    }
  }), _c('div', {
    staticClass: "pause-button icon-video-pause",
    class: {
      hide: !_vm.videoPlaying
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.pauseVideo($event);
      }
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "volume-control"
  }, [_c('div', {
    staticClass: "volume-button icon-video-audio-on",
    class: {
      hide: _vm.videoMuted
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.muteAudio($event);
      }
    }
  }), _c('div', {
    staticClass: "volume-button-mute icon-video-audio-off",
    class: {
      hide: !_vm.videoMuted
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.unmuteAudio($event);
      }
    }
  })])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "progress-background icon-video-timeline"
  }, [_c('div', {
    staticClass: "icon-video-scrubber"
  })])]);
}]

export { render, staticRenderFns }